// extracted by mini-css-extract-plugin
export default {"form":"VendorCreditsForm-module_form__e5jIW","remove":"VendorCreditsForm-module_remove__xevNS","cornerLabel":"VendorCreditsForm-module_cornerLabel__u0bXE"};